import React from 'react';

import Diversity1Icon from '@mui/icons-material/Diversity1';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import GroupsIcon from '@mui/icons-material/Groups';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SecurityIcon from '@mui/icons-material/Security';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PortraitRounded from '@mui/icons-material/PortraitRounded';


export const headSection = {
  logo: 'here',
  topTitle: 'No. 5612',
  topSubTitle: '- Ascot'
}


export const cardsData = [
  {'title': 'Learn Our History', 'price': 250,
    'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-13-01-exam-revision.jpg',
    'desc': 'Established over 300 years ago, our rich history inspires new members from all walks of life.',
    'id': 2},
  {'title': 'Get Inspired', 'price': 100,
  'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-14-34-exam-revision.jpg',
  'desc': 'Our Values lie in Integrity, Friendship, Respect and Charity to bring about a better future.',
    'id': 1},
  {'title': 'Become a member', 'price': 100,
  'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-13-29-exam-revision.jpg',
  'desc': 'Join in the events and ceremonies and make a difference in your community.',
    'id': 3},
  {'title': 'Contribute to charity', 'price': 100,
  'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-14-01-exam-revision.jpg',
  'desc': 'Support an existing cause or start your own with the help of our members.',
    'id': 4}
  ];

export const charitableCardsData = [
  {'title': 'Rodley Nature Reserve', 'price': 250,
    'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-29-21-exam-revision.jpg',
    'desc': 'Trustees were delighted to welcome representatives from the Freemasons of Yorkshire West Riding for ' +
      'the presentation of a cheque for £1730 in support of the new accessible toilet facilities.',
    'id': 2},
  {'title': 'Teaching children how to take photographs', 'price': 100,
  'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-28-57-exam-revision.jpg',
  'desc': 'Brother Chris Owen started working with children almost 7 years ago, whilst still working as a professional photographer.',
    'id': 1},
  {'title': 'Farsley Graveyard Project', 'price': 100,
  'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-26-10-25-11-28-32-exam-revision.jpg',
  'desc': 'A new project to open up and restore a neglected graveyard and turn it into a community asset has been ' +
    'awarded a £1,700 grant from the West Yorkshire Freemasons.',
    'id': 3}
  ];

export const jobsData = [
  {'title': 'Full Time', 'price': 250,
    'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/n-27u-24-12-23-21-03-42-exam-revision.jpg',
    'desc': 'Full time roles ...', 'id': 2},
  {'title': 'Part Time', 'price': 100,
    'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/n-27u-24-12-23-21-03-42-exam-revision.jpg',
    'desc': 'Part time roles ...', 'id': 1},
  {'title': 'Temporary', 'price': 100,
    'remote_image': 'https://idaily-img.s3.eu-west-2.amazonaws.com/n-27u-24-12-23-21-03-42-exam-revision.jpg',
    'desc': 'Temporary roles ...', 'id': 1}
];

export const ourTeam = [
  {
    id: 1,
    title: 'Manager',
    desc: 'The Residents Manager is available Monday to Friday, 9am-5pm, with on-call responsibilities over weekends. ' +
      'They oversee staff supervision and ensure a safe, supportive environment that fosters resident independence ' +
      'and well-being.',
    icon: <PortraitRounded style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 2,
    title: 'Senior Support Worker',
    desc: 'A Senior Support Worker is on duty at all times 24/7. They mentor junior support workers, ensure effective ' +
      'implementation of care plans, collaborate with management on service quality, and provide guidance on ' +
      'best practices in care delivery. They also assist in training new staff.',
    icon: <PortraitRounded style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 3,
    title: 'Support Workers',
    desc: ' Support Workers work  alongside a Senior Support Workers. They provide direct support to ' +
      'residents in their daily activities, promoting independence and well-being.',
    icon: <PortraitRounded style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 4,
    title: 'Administrator',
    desc: 'The Administrator works Monday to Friday, 9am-5pm, managing administrative tasks including records, ' +
      'scheduling, compliance, budget oversight, and communication with clients, families, and external ' +
      'agencies to ensure all documentation is up to date.',
    icon: <PortraitRounded style={{ fontSize: 50, color: '#133459' }} />
  }
]

export const ourValues = [
   {
    id: 1,
    title: 'Respect and Dignity',
    desc: 'We honor each individual’s unique identity, choices, and preferences, ensuring they are treated with respect and dignity at all times.',
    icon: <Diversity1Icon style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 2,
    title: 'Empowerment and Independence',
    desc: 'We encourage and support individuals to develop their skills, make their own decisions, and lead independent, fulfilling lives..',
    icon: <AccessibilityNewIcon style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 3,
    title: 'Inclusivity and Community Integration',
    desc: 'We promote social inclusion by helping individuals actively participate in their communities and build meaningful relationships.',
    icon: <GroupsIcon style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 4,
    title: 'Person-Centred Care',
    desc: 'Our support is tailored to meet the specific needs, aspirations, and goals of each individual, fostering a sense of purpose and achievement..',
    icon: <FavoriteIcon style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 5,
    title: 'Safety and Well-Being',
    desc: 'We provide a safe, nurturing environment where individuals can thrive, prioritizing their physical, mental, and emotional well-being.',
    icon: <SecurityIcon style={{ fontSize: 50, color: '#133459' }} />
  },
  {
    id: 6,
    title: 'Collaboration and Trust',
    desc: 'We work closely with individuals, families, and professionals to deliver the best outcomes, fostering trust and transparency.',
    icon: <HandshakeIcon style={{ fontSize: 50, color: '#133459' }} />
  },
];

export const howWeHelp = {
  howText: 'We are passionate about helping clients on how they can utilise their information technology (IT)' +
    ' to optimally achieve their business goals. Let our consultants soothe your IT headache.'
}